{
  "Announcements": "Annonces",
  "MarkAllAsRead": "Tout marquer comme lu",
  "NoLinkNotification": "Aucun lien disponible pour cette notification",
  "Notification": "Notifications",
  "ViewAll": "Tout afficher"
}
